import Toast from "@/common/components/ui/toast";
import Dashboard from "@/common/components/layout/Dashboard";
import { ToastProvider } from "@/common/components/ui/toast/toast.provider";
import AutomaticRenewalsTable from "./Tables/AutomaticRenewals.table";

export default function AutomaticRenewalsPage() {
  return (
    <ToastProvider>
      <Dashboard>
        <AutomaticRenewalsTable />
      </Dashboard>
      <Toast />
    </ToastProvider>
  );
}
